import { createAction, props } from '@ngrx/store';
import { Merchant } from '@print2go/types';

export const loadMerchant = createAction('[Merchant] Load Merchant');
export const loadMerchantSuccess = createAction(
  '[Merchant] Load Merchant Success',
  props<{ merchant: Merchant | null }>()
);
export const loadMerchantFailure = createAction('[Merchant] Load Merchant Failure', props<{ error: any }>());
export const updateMerchant = createAction(
  '[Merchant] Update Merchant',
  props<{ data: Partial<Merchant> & Pick<Merchant, 'uid'> }>()
);
export const updateMerchantSuccess = createAction('[Merchant] Update Merchant Success', props<{ data: Merchant }>());
export const updateMerchantFailure = createAction('[Merchant] Update Merchant Failure', props<{ error: any }>());